import React, { useEffect, useState } from "react";
import { Link, useNavigate, NavLink } from "react-router-dom";
import {Form, InputGroup, Button, Card, Col, Row, Pagination} from "react-bootstrap";
import { FaComments, FaClock, FaSearch, FaReply, FaTimesCircle } from "react-icons/fa";
import Select from "react-select";
import { Table, Modal, notification } from "antd";
import { jwtDecode } from "jwt-decode";
import ReactPaginate from "react-paginate";
import { baseApiUrl } from "../../../services/api";

function Discussion() {
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(5);
  const questionsPerPage = 4;
  const [currentUser, setCurrentUser] = useState(null);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [showReplyForm, setShowReplyForm] = useState(false);
  const [replyMessage, setReplyMessage] = useState("");
  const [visibleResponses, setVisibleResponses] = useState({});
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [titre, setTitre] = useState("");
  const [description, setDescription] = useState("");
  const [categorieId, setCategorieId] = useState("");
  const [selectedCategorie, setSelectedCategorie] = useState("");

  // Custom theme colors
  const themeColors = {
    primary: "#2E8B57", // Sea Green (replacing blue)
    secondary: "#3CB371", // Medium Sea Green
    light: "#F0FFF0", // Honeydew
    accent: "#66CDAA", // Medium Aquamarine
    text: "#2F4F4F", // Dark Slate Gray
    border: "#8FBC8F", // Dark Sea Green
  };

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  const fetchQuestions = async () => {
    try {
      const response = await baseApiUrl.get("/question/liste");
      console.log("Données reçues des questions:", response.data);

      const questions = Array.isArray(response.data) ? response.data : [];

      // Trier les questions par date de création décroissante (du plus récent au plus ancien)
      const sortedQuestions = questions.sort((a, b) => new Date(b.created) - new Date(a.created));

      // Filtrer les questions actives
      const filteredQuestions = sortedQuestions.filter((question) => question.actif === true);

      // Filtrer les réponses actives pour chaque question
      const questionsWithActiveResponses = filteredQuestions.map((question) => ({
        ...question,
        reponses: question.reponses ? question.reponses.filter((reponse) => reponse.actif === true) : []
      }));

      // Stocker les questions triées et filtrées dans l'état
      setQuestions(questionsWithActiveResponses);
      console.log("Questions triées et filtrées:", questionsWithActiveResponses);
    } catch (error) {
      console.error("Erreur lors de la récupération des questions:", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded);
        console.log("Utilisateur connecté:", decoded);
      } catch (error) {
        console.error("Erreur lors du décodage du token:", error);
      }
    } else {
      console.warn("Aucun token trouvé dans localStorage.");
    }

    const fetchCategories = async () => {
      try {
        const response = await baseApiUrl.get("/categorie/liste");

        // Transformer les données pour correspondre au format des options de <Select>
        const options = response.data.map((category) => ({
          value: category.id,
          label: category.nom,
        }));

        setCategoriesOptions(options);
      } catch (error) {
        console.error("Erreur lors de la récupération des catégories:", error);
      }
    };

    fetchCategories();
    fetchQuestions();
  }, []);

  // Calculer les informations à afficher sur la page actuelle
  const offset = currentPage * itemsPerPage;
  const currentQuestions = questions.slice(offset, offset + itemsPerPage);

  // Gestion du changement de page
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSubmit = () => {
    // setCurrentPage(pageNumber);
  };

  const handleAddQuestion = async (e) => {
    e.preventDefault();

    const questionData = {
      description: description,
      categorieId: selectedCategorie,
    };

    console.log("Données de la question à ajouter:", questionData);

    try {
      const response = await baseApiUrl.post(
        "/question/create",
        questionData
      );

      if (response.status !== 200 && response.status !== 201) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const newQuestion = response.data;

      setQuestions([newQuestion, ...questions]);
      openNotificationWithIcon("success", "Question ajoutée avec succès.");
      fetchQuestions();
    } catch (error) {
      openNotificationWithIcon(
        "error",
        "Erreur lors de l'ajout de la question."
      );
      console.error("Erreur:", error);
    }

    resetForm();
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const resetForm = () => {
    setTitre("");
    setDescription("");
    setSelectedCategorie("");
    setIsEditMode(false);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
  };

  const handleShowResponses = (questionId) => {
    navigate(`/discussion/${questionId}`);
  };

  const handleShowReplyForm = (questionId) => {
    console.log("ID de la question pour le formulaire de réponse :", questionId);
    setSelectedQuestion(questionId);
    setShowReplyForm(true);
  };

  const handleReplyChange = (event) => {
    setReplyMessage(event.target.value);
  };

  const handleSubmitReply = async (e) => {
    e.preventDefault();

    if (!replyMessage.trim()) {
      console.log("Reply message is empty");
      return;
    }

    const nouvelleReponse = {
      questionId: selectedQuestion,
      contenu: replyMessage,
      utilisateur: {
        id: currentUser.id,
      },
    };

    try {
      const response = await baseApiUrl.post(
        "/reponse",
        nouvelleReponse,
      );

      console.log("Réponse du serveur:", response);

      setReplyMessage("");
      setShowReplyForm(false);
      openNotificationWithIcon("success", "Réponse ajoutée avec succès.");

      // Mettez à jour l'état des questions
      setQuestions(prevQuestions =>
        prevQuestions.map(q =>
          q.id === selectedQuestion
            ? { ...q, reponses: [...q.reponses, response.data] }
            : q
        )
      );
    } catch (error) {
      console.error("Erreur lors de l'envoi de la réponse:", error);
    }
  };

  const handleChange = (selectedOption) => {
    setSelectedCategorie(selectedOption);
  };

  const formatTimeDifference = (date) => {
    const now = new Date();
    const timeDifference = now - date;
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    const optionsTime = { hour: "2-digit", minute: "2-digit", hour12: false };
    const timeString = date.toLocaleTimeString([], optionsTime);
    const optionsDate = { year: "numeric", month: "long", day: "numeric" };
    const dateString = date.toLocaleDateString([], optionsDate);

    if (daysDifference === 0) {
      return {
        text: "Aujourd'hui",
        time: timeString,
        date: dateString,
        color: themeColors.primary,
      };
    } else if (daysDifference === 1) {
      return {
        text: "Il y a 1 jour",
        time: timeString,
        date: dateString,
        color: themeColors.secondary,
      };
    } else {
      return {
        text: `Il y a ${daysDifference} jours`,
        time: timeString,
        date: dateString,
        color: themeColors.secondary,
      };
    }
  };

  // Styling for Select component
  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: themeColors.border,
      boxShadow: `0 0 0 1px ${themeColors.border}`,
      '&:hover': {
        borderColor: themeColors.primary
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? themeColors.primary : state.isFocused ? themeColors.light : null,
      color: state.isSelected ? 'white' : themeColors.text,
    }),
  };

  // Custom styles for pagination
  const paginationStyle = {
    display: 'flex',
    listStyle: 'none',
    justifyContent: 'center',
    padding: 0,
    margin: '20px 0',
  };

  const pageItemStyle = {
    margin: '0 5px',
    padding: '8px 12px',
    border: `1px solid ${themeColors.border}`,
    borderRadius: '4px',
    cursor: 'pointer',
    color: themeColors.text,
    transition: 'all 0.3s ease',
  };

  const pageItemActiveStyle = {
    ...pageItemStyle,
    backgroundColor: themeColors.primary,
    color: 'white',
    borderColor: themeColors.primary,
  };

  return (
    <div className="discussion-container" style={{ backgroundColor: "#FAFFF9", color: themeColors.text }}>
      <div className="container py-5">
        {/* Menu de navigation */}
        <nav className="mb-5">
          <div className="d-flex justify-content-center">
            <NavLink
              to="/acceuil/forum"
              className={({ isActive }) =>
                `px-4 py-2 mx-2 rounded-md text-decoration-none ${
                  isActive
                    ? `bg-${themeColors.primary} text-white`
                    : `text-${themeColors.text} hover:bg-${themeColors.light}`
                }`
              }
              style={{
                transition: "all 0.3s ease",
                fontWeight: "500",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                border: `1px solid ${themeColors.border}`,
              }}
            >
              Forum
            </NavLink>
            <NavLink
              to="/acceuil/membre"
              className={({ isActive }) =>
                `px-4 py-2 mx-2 rounded-md text-decoration-none ${
                  isActive
                    ? `bg-${themeColors.primary} text-white`
                    : `text-${themeColors.text} hover:bg-${themeColors.light}`
                }`
              }
              style={{
                transition: "all 0.3s ease",
                fontWeight: "500",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                border: `1px solid ${themeColors.border}`,
              }}
            >
              Membre
            </NavLink>
          </div>
        </nav>

        {!currentUser && (
          <div className="alert alert-warning text-center mb-4" style={{ borderLeft: `4px solid ${themeColors.secondary}` }}>
            Veuillez vous connecter pour poser une question ou répondre.
          </div>
        )}

        <div className="row">
          <div className="col-lg-12">
            <div className="content-area p-4" style={{ backgroundColor: "white", borderRadius: "8px", boxShadow: "0 2px 10px rgba(0,0,0,0.05)" }}>
              {Array.isArray(currentQuestions) &&
                currentQuestions.map((question) => {
                  const { text, time, date, color } = formatTimeDifference(
                    new Date(question.creationDate)
                  );

                  return (
                    <div
                      className="question-box mb-4 p-4"
                      key={question.id}
                      style={{
                        borderRadius: "8px",
                        border: `1px solid ${themeColors.border}`,
                        boxShadow: "0 2px 6px rgba(0,0,0,0.03)",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center">
                          <div className="user-image" style={{ marginRight: "12px" }}>
                            <img
                              src={
                                question.utilisateur?.photo
                                  ? baseApiUrl.defaults.baseURL + `/image/${question.utilisateur.photo}`
                                  : "https://via.placeholder.com/30"
                              }
                              alt={
                                question.utilisateur?.prenom ||
                                "Image de l'utilisateur"
                              }
                              className="rounded-circle"
                              width="50"
                              height="50"
                              style={{ border: `2px solid ${themeColors.primary}` }}
                            />
                          </div>
                          <div>
                            <h5 style={{ marginBottom: "2px", color: themeColors.primary }}>
                              {question.utilisateur?.prenom}
                            </h5>
                            <p className="text-muted" style={{ fontSize: "0.85rem" }}>{date}</p>
                          </div>
                        </div>

                        <Button
                          variant="outline-success"
                          size="sm"
                          onClick={() => handleShowReplyForm(question.id)}
                          disabled={!currentUser}
                          style={{
                            backgroundColor: "transparent",
                            borderColor: themeColors.primary,
                            color: themeColors.primary,
                            transition: "all 0.3s ease",
                          }}
                          className="reply-btn"
                        >
                          <FaReply style={{ marginRight: "5px" }} /> Répondre
                        </Button>
                      </div>

                      <div className="category-badge my-2">
                        <span
                          className="badge"
                          style={{
                            backgroundColor: themeColors.light,
                            color: themeColors.primary,
                            padding: "5px 10px",
                            borderRadius: "20px",
                            fontSize: "0.8rem"
                          }}
                        >
                          {question.categorie?.nom}
                        </span>
                      </div>

                      <div className="question-content mt-3 mb-3">
                        <p style={{ lineHeight: "1.6" }}>{question.description}</p>
                      </div>

                      <div className="question-actions mt-3">
                        <Button
                          style={{
                            backgroundColor: themeColors.primary,
                            borderColor: themeColors.primary,
                            color: "white",
                            fontWeight: "500",
                            transition: "all 0.3s ease",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          }}
                          onClick={() => handleShowResponses(question.id)}
                          className="view-responses-btn"
                        >
                          <FaComments style={{ marginRight: "8px" }} />
                          Voir les réponses ({question.reponses ? question.reponses.filter(reponse => reponse.actif === true).length : 0})
                        </Button>
                      </div>

                      {showReplyForm && selectedQuestion === question.id && (
                        <div className="reply-form-container mt-4 p-3" style={{ backgroundColor: themeColors.light, borderRadius: "8px" }}>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 style={{ color: themeColors.primary, marginBottom: "0" }}>Votre réponse</h6>
                            <Button
                              variant="link"
                              size="sm"
                              onClick={() => {
                                setShowReplyForm(false);
                                setReplyMessage("");
                              }}
                              style={{
                                color: "#DC3545",
                                textDecoration: "none",
                                padding: "0",
                              }}
                            >
                              <FaTimesCircle /> Annuler
                            </Button>
                          </div>

                          <Form onSubmit={handleSubmitReply}>
                            <Form.Group controlId="replyMessage">
                              <Form.Control
                                as="textarea"
                                rows={3}
                                value={replyMessage}
                                onChange={handleReplyChange}
                                placeholder="Votre réponse..."
                                required
                                style={{
                                  border: `1px solid ${themeColors.border}`,
                                  marginBottom: "10px",
                                  resize: "vertical",
                                  minHeight: "100px",
                                  boxShadow: "none",
                                  fontSize: "0.95rem"
                                }}
                              />
                            </Form.Group>
                            <div className="d-flex justify-content-end">
                              <Button
                                variant="success"
                                type="submit"
                                style={{
                                  backgroundColor: themeColors.primary,
                                  borderColor: themeColors.primary,
                                  fontWeight: "500"
                                }}
                              >
                                Envoyer
                              </Button>
                            </div>
                          </Form>
                        </div>
                      )}

                      {visibleResponses[question.id] && (
                        <div className="responses-container mt-3">
                          <h6 style={{ color: themeColors.primary, marginBottom: "15px" }}>Réponses:</h6>
                          {question.reponses.map((reponse, index) => (
                            <Card
                              key={index}
                              className="mb-3 ml-4"
                              style={{
                                backgroundColor: themeColors.light,
                                borderRadius: "12px",
                                borderColor: themeColors.border,
                                marginLeft: "25px",
                              }}
                            >
                              <Card.Body>
                                <Row>
                                  <Col xs={2} md={1}>
                                    <img
                                      src={
                                        reponse.utilisateur?.photo
                                          ? baseApiUrl.defaults.baseURL + `/image/${reponse.utilisateur.photo}`
                                          : "https://via.placeholder.com/30"
                                      }
                                      alt={reponse.utilisateur?.prenom}
                                      className="rounded-circle"
                                      width="45"
                                      height="45"
                                      style={{ border: `2px solid ${themeColors.secondary}` }}
                                    />
                                  </Col>
                                  <Col xs={10} md={11}>
                                    <h6 style={{ color: themeColors.secondary, marginBottom: "5px" }}>
                                      <strong>
                                        {reponse.utilisateur?.nom}
                                      </strong>
                                    </h6>
                                    <p style={{ marginBottom: "8px" }}>{reponse.contenu}</p>
                                    <div className="text-muted" style={{ fontSize: "0.8rem" }}>
                                      <FaClock style={{ marginRight: "5px" }} /> {time} - {date}
                                    </div>
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Card>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}

              {/* Pagination */}
              <div className="pagination-container mt-4 mb-5">
                <ReactPaginate
                  previousLabel={<i className="fa-solid fa-angle-left"></i>}
                  nextLabel={<i className="fa-solid fa-angle-right"></i>}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={questions.length > 0 ? Math.ceil(questions.length / itemsPerPage) : 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                  activeLinkClassName={"active"}
                  disabledClassName={"disabled"}
                  breakLinkClassName={"page-link"}
                  style={paginationStyle}
                  activeStyle={pageItemActiveStyle}
                  pageStyle={pageItemStyle}
                />
              </div>

              {/* Ask Question Form */}
              {currentUser && (
                <div
                  className="ask-question-container p-4 mt-4"
                  style={{
                    backgroundColor: themeColors.light,
                    borderRadius: "8px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                    border: `1px solid ${themeColors.border}`
                  }}
                >
                  <div className="text-center mb-4">
                    <h4 style={{ color: themeColors.primary, fontWeight: "600" }}>Poser une question</h4>
                    <div className="divider" style={{
                      height: "3px",
                      width: "60px",
                      backgroundColor: themeColors.primary,
                      margin: "10px auto"
                    }}></div>
                  </div>

                  <form onSubmit={handleAddQuestion}>
                    <div className="row">
                      <div className="col-md-12 mb-4">
                        <div className="form-group">
                          <label htmlFor="category-select" style={{ color: themeColors.text, fontWeight: "500", marginBottom: "8px" }}>Catégorie</label>
                          <Select
                            id="category-select"
                            value={categoriesOptions.find(
                              (option) => option.value === selectedCategorie
                            )}
                            onChange={(option) =>
                              handleChange(option ? option.value : "")
                            }
                            options={categoriesOptions}
                            placeholder="Sélectionnez une catégorie..."
                            isSearchable
                            required
                            styles={customSelectStyles}
                          />
                        </div>
                      </div>

                      <div className="col-md-12 mb-4">
                        <div className="form-group">
                          <label htmlFor="question-text" style={{ color: themeColors.text, fontWeight: "500", marginBottom: "8px" }}>Message</label>
                          <textarea
                            id="question-text"
                            style={{
                              minHeight: "200px",
                              width: "100%",
                              padding: "12px",
                              borderRadius: "6px",
                              border: `1px solid ${themeColors.border}`,
                              fontSize: "0.95rem"
                            }}
                            className="form-control"
                            placeholder="Décrivez votre question en détail..."
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            required
                          ></textarea>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="d-flex justify-content-center mt-3">
                          <button
                            className="btn"
                            type="submit"
                            style={{
                              backgroundColor: themeColors.primary,
                              color: "white",
                              padding: "10px 25px",
                              borderRadius: "30px",
                              border: "none",
                              fontWeight: "500",
                              fontSize: "1rem",
                              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                              transition: "all 0.3s ease"
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = themeColors.secondary}
                            onMouseOut={(e) => e.target.style.backgroundColor = themeColors.primary}
                          >
                            Envoyer votre question
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .discussion-container {
          min-height: 100vh;
          padding: 20px 0;
        }

        .page-link {
          color: ${themeColors.primary};
          background-color: #fff;
          border: 1px solid ${themeColors.border};
        }

        .page-item.active .page-link {
          background-color: ${themeColors.primary};
          border-color: ${themeColors.primary};
        }

        .reply-btn:hover {
          background-color: ${themeColors.primary} !important;
          color: white !important;
        }

        .view-responses-btn:hover {
          background-color: ${themeColors.secondary} !important;
          border-color: ${themeColors.secondary} !important;
        }

        .question-box:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
        }
      `}</style>
    </div>
  );
}

export default Discussion;
